import { render, staticRenderFns } from "./AddTest.vue?vue&type=template&id=5b55bbfe&scoped=true"
import script from "./AddTest.vue?vue&type=script&lang=js"
export * from "./AddTest.vue?vue&type=script&lang=js"
import style0 from "./AddTest.vue?vue&type=style&index=0&id=5b55bbfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b55bbfe",
  null
  
)

export default component.exports